import { getApiMode, type ApiMode } from '../env';

const API_BASE_URLS: Record<ApiMode, string> = {
  development: 'https://slb.medv.ru/',
  production: 'https://portal.simpleloan.ru/',
};

export function useBaseUrl() {
  return API_BASE_URLS[getApiMode()];
}
